<template>
  <div class="container">
    <div v-if="contentToShow === 'notfound'">
      <h1>Page not found</h1>
      <p>This page does not exist, please check the address.</p>
    </div>

    <div v-else-if="contentToShow === 'privacy'">
      <h1>Privacy Policy</h1>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:18pt;">
        <span style="font-family:'Calibri Light';">PFX Privacy Notice</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span style="font-family:'Calibri Light';">Last updated: February 17, 2020</span>
        <span style="font-family:'Calibri Light';">.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >This Privacy Notice (“Privacy Notice”) describes how PFX, Inc., a Delaware corporation, and its affiliates and subsidiaries (collectively, “we,” “us,” “our,” or “PFX”) handle your personal information in connection with the following services provided by PFX (collectively, the “Services”):</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >PFX’s websites (including, without limitation,&nbsp;</span>
          <a href="http://www.pfxinc.com">
            <u>
              <span
                style="font-family:'Calibri Light'; font-size:11pt; color:#0000ff;"
              >www.pfxinc.com</span>
            </u>
          </a>
          <span style="font-family:'Calibri Light'; font-size:11pt;">&nbsp;</span>
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >and any other website where this Privacy Notice is posted) (collectively, the “PFX Websites”)</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >PFX’s online platform available at&nbsp;</span>
          <a href="https://www.pfxinc.com">
            <span style="font-family:'Calibri Light'; font-size:11pt;">https://www.pfxinc.com</span>
          </a>
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >&nbsp;(the, “PFX Platform”)&nbsp;</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Any other tools, documents, emails, software programs, applications (including mobile applications), and other services provided to you by PFX through or in connection with the PFX Platform or any PFX Websites.</span>
        </li>
      </ul>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >PFX has a strong commitment to providing information tailored to your individual needs while providing excellent service to all of our visitors and customers, including respecting concerns about privacy. We understand that you may have questions about whether and how we collect and use information. This Privacy Notice details the steps we take to respect your privacy concerns. If, after reviewing this Privacy Notice, you have any questions or privacy concerns, please send us an email to contact@pfxinc.com.&nbsp;</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Changes to This Privacy Notice</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We may update this Privacy Notice from time to time. If we make material changes to this Privacy Notice, we will post our updated Privacy Notice on the Services where applicable, and for a reasonable period of time we will post notice of the change so it is visible to visitors and users after the change is posted. By your continued use of the Services, you will be deemed to consent to the terms of the revised Privacy Notice.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span
          style="font-family:Calibri; font-weight:normal;"
        >What Personal Information Do We Collect?</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Generally speaking, “personal information“ means any information about an individual from which that person may be identified. Personal Information includes obvious things, like your name, telephone number, email address and street address, as well as less obvious things like your IP address, device ID and location information. Personal information does not, however, include information from which the identity of an individual has been definitively removed (also known as anonymous or anonymized data).&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >In order to provide the Services, we collect various types of information. We collect Personal Information&nbsp;</span>
        <u>
          <span style="font-family:'Calibri Light';">directly</span>
        </u>
        <span
          style="font-family:'Calibri Light';"
        >&nbsp;from you when you provide it to us, such as when you create an account with us or otherwise communicate with us, verbally or in writing. We also may collect information&nbsp;</span>
        <u>
          <span style="font-family:'Calibri Light';">indirectly</span>
        </u>
        <span
          style="font-family:'Calibri Light';"
        >&nbsp;through automated technologies, such as cookies, or from third parties.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <a name="_Toc24646128">
          <span style="font-family:'Calibri Light'; color:#0070c0;">Personal Information You Provide</span>
        </a>
        <span style="font-family:'Calibri Light'; color:#0070c0;">&nbsp;to Us</span>
      </p>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span style="font-family:'Calibri Light';">You can visit the&nbsp;</span>
        <span style="font-family:'Calibri Light';">PFX Websites</span>
        <span
          style="font-family:'Calibri Light';"
        >&nbsp;without having to submit any personal information about yourself to us. However, to use certain services and functionality of the Services, such as to enter into a real estate transaction, you will be required to register for an account with PFX.&nbsp;</span>
        <span
          style="font-family:'Calibri Light';"
        >You may provide us with personal information in a variety of circumstances when you:</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span
            style="font-family:'Calibri Light';"
          >Create an account through the Services (“PFX Account”) or updating your PFX Account profile</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span
            style="font-family:'Calibri Light';"
          >Register for or participate in a transaction event</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Submit an employment application</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Complete online forms</span>
        </li>
        <li
          style="margin-left:28.06pt; margin-bottom:6pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Enter into a transaction with us.&nbsp;</span>
        </li>
      </ul>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >Because our Services serve different participants in an auction and/or transaction, personal information may be submitted by brokers, buyers or sellers. This information may include:</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">First and last name</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">E-mail address (personal or professional)</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Company name</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Mailing address</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Telephone number (including office number)</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Fax number</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Username</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Password</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span style="font-family:'Calibri Light';">Billing information</span>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span
            style="font-family:'Calibri Light';"
          >Financial information, such as bank statement (proof of funds) or pre-qualification letters from lenders</span>
        </li>
        <li
          style="margin-left:28.06pt; margin-bottom:6pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt; background-color:#ffffff;"
        >
          <span
            style="font-family:'Calibri Light';"
          >Any information voluntarily submitted as part of a pending transaction.</span>
        </li>
      </ul>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >Importantly, because real estate transactions require substantial information from both the buyer and seller side, we will collect a variety of other information typically exchanged in connection with real estate transactions and related financing transactions.&nbsp;</span>
        <strong>
          <span
            style="font-family:'Calibri Light';"
          >In some cases, this information includes government-issued identification documents or related data (such as a driver license number)</span>
        </strong>
        <span
          style="font-family:'Calibri Light';"
        >. Some data may be collected offline and not via the website, in most cases between buyers and sellers, or their respective agents or brokers.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <span
          style="font-family:'Calibri Light'; color:#0070c0;"
        >Personal Information We Collect Indirectly</span>
      </p>
      <h6 style="margin-top:6pt; margin-bottom:6pt; font-size:11pt;">
        <em>
          <span
            style="font-family:'Calibri Light'; font-weight:normal; color:#002060;"
          >Automatically-Collected Information</span>
        </em>
      </h6>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >If you are visiting the PFX Websites or using our Services, we automatically collect information about the computer or devices (including mobile devices) you use to access the Services, and your interactions with the Services, such as through cookies and other automated technologies. For example, we may collect and store information such as your browser type, IP address, language, operating system, location of your wireless device (e.g., latitude and longitude), the state or country from which you accessed the Services, unique device identifier, the pages you view, length of time spent on pages, communications with other users through the Services, the Services you use and the manner in which you use such Services (e.g., the content you access, view, click on, search for, post, favorite, vote, follow, share, upload, or tag), the date and time of your visit, the websites you visited immediately before and after visiting the PFX Websites or accessing the PFX Platform, error logs, and other hardware and software information, as well as other geographic and demographic information.</span>
        <span style="font-family:'Calibri Light';">&nbsp;&nbsp;</span>
      </p>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >We may use cookies and similar tools, to assist in collecting this information, as further explained below. We may use this information to formulate statistical models about use of the Services, enhance the Services for our users, and provide you with information about new opportunities, and tailored content, advertising, marketing and as otherwise discussed in this Privacy Notice.&nbsp;</span>
      </p>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light'; font-size:11pt;"
        >For more information about our use of cookies and similar technologies, please see&nbsp;</span>
        <a href="#_Cookies" style="text-decoration:none;">
          <u>
            <span style="font-family:'Calibri Light'; font-size:11pt; color:#0000ff;">Cookies</span>
          </u>
        </a>
        <span style="font-family:'Calibri Light'; font-size:11pt;">&nbsp;below.</span>
        <span style="font-family:'Calibri Light'; font-size:11pt;">&nbsp;&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Certain information specified in the preceding paragraphs (such as what content you access, view, click on or search for on the Services, the devices from which you access such content and the length of time for which you view same), may be associated with your PFX Account. PFX may use the account details from your PFX Account across all the Services that PFX offers. Accordingly, if you have created a PFX Account for one PFX Website or aspect of the Services, you may be able to use the same username and password for accounts on other PFX Websites or with respect to other aspects of the Services, without creating accounts for each such PFX Website or aspect of the Services. Related information may be used as permitted by this Privacy Notice.</span>
      </p>
      <h6 style="margin-top:6pt; margin-bottom:6pt; font-size:11pt;">
        <em>
          <span
            style="font-family:'Calibri Light'; font-weight:normal; color:#002060;"
          >Location Information</span>
        </em>
      </h6>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >We also collect broad geographic location (e.g., country or city-level location) based upon IP address, in order to determine the popularity of our products around the world and guide product updates and marketing strategies.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Please check your specific browser or device settings to disable location services.</span>
      </p>
      <h6 style="margin-top:6pt; margin-bottom:6pt; font-size:11pt;">
        <em>
          <span
            style="font-family:'Calibri Light'; font-weight:normal; color:#002060;"
          >Information Obtained from Third Parties and Public Records</span>
        </em>
      </h6>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If you have a PFX Account and participate in a transaction, we also may acquire personal information from other sources such as offline records, publicly available information, or from third parties. Most of this information is necessary in order to complete a real estate transaction.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <span
          style="font-family:'Calibri Light'; color:#0070c0;"
        >User-Initiated Communications and Public Forums</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >From time to time, portions of the Services may enable you to send emails and other types of messages to us or to third parties, or to participate in public forums. Whenever you choose to initiate these kinds of communications with us, or anyone else, you may be contacted in return. Such communications you send or messages you post, when viewed by others, may be identified by your actual name and/or your username.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If you post to any existing or future public forums, remember that these public forums are&nbsp;</span>
        <strong>
          <span style="font-family:'Calibri Light';">open to the public</span>
        </strong>
        <span
          style="font-family:'Calibri Light';"
        >, and, therefore, your postings can be seen by anyone, may be indexable by search engines, and are not protected by us or any other entity.&nbsp;</span>
        <strong>
          <span
            style="font-family:'Calibri Light';"
          >Please use your discretion when deciding whether and what to post and whom to contact and message, and understand that some of your personal information may be visible</span>
        </strong>
        <span style="font-family:'Calibri Light';">.&nbsp;</span>
        <strong>
          <span
            style="font-family:'Calibri Light';"
          >Please do not post personal information about other individuals without their explicit consent</span>
        </strong>
        <span style="font-family:'Calibri Light';">.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We reserve the right, in our sole discretion, to monitor, edit or delete postings from our bulletin boards and discussion groups, including without limitations where any postings affect the privacy rights of others.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <span style="font-family:'Calibri Light'; color:#0070c0;">Third Parties</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We may collect personal information from third parties in connection with and in order to facilitate a transaction. If so, we will inform you of such collection.</span>
      </p>
      <p
        style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt; background-color:#ffffff;"
      >
        <span
          style="font-family:'Calibri Light';"
        >In some cases, you may invite others to participate in an auction, in which case we may collect emails addresses. If so, please ensure that you are providing such information with the consent of such individuals.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <a name="_Cookies"></a>
        <span style="font-family:Calibri; font-weight:normal;">Cookies</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <span
          style="font-family:'Calibri Light'; color:#0070c0;"
        >What are Cookies, Pixels and Local Storage?</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >The Services use “cookie” technology and similar online tools, such as web beacons and web pixels. “Cookies” are small files that a website stores on a user’s computer or device and through which personal information may be collected. The Services use cookies for various purposes, including to keep the information you enter on multiple pages together.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Some cookies are first-party cookies – meaning our cookies – and others are third-party cookies, meaning that they are placed on the Services by authorized third parties. We and third parties also use session and persistent cookies for analytics and advertising purposes, as described below. Most web browsers automatically accept cookies, but you may set your browser to block certain cookies (consult the instructions for your particular browser on how to do this). Please note that if you decide to block cookies, this may interfere with your ability to perform certain transactions, use certain functionality, and access certain content on the Services.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We use “session” cookies, meaning that they are automatically deleted from your hard drive after you close your browser at the end of your session. Session cookies are used to optimize performance of the Services and to limit the amount of redundant data that is downloaded during a single session.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We also use “persistent” cookies, which remain on your computer or device unless deleted by you (or by your browser settings). We use persistent cookies for various purposes, such as statistical analysis of performance to ensure the ongoing quality of our services.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >A pixel is a small amount of code on a web page or in an email notification. As many services do, we (or authorized third parties) use pixels to learn whether you’ve interacted with certain web or email content. This helps us measure and improve our services and personalize your experience.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Local storage is an industry-standard technology that allows a website or application to store information locally on your computer or mobile device. We use local storage to customize what we show you based on your past interactions with the PFX Websites.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Some of the cookies or similar technologies that we used are “essential” for the PFX Websites to function. These are all the cookies without which the PFX Websites could not perform basic functions. They may be set automatically when pages load, or as a result of a user request that cannot be fulfilled without the use of the cookie. Generally these are session cookies that expire on closing the browser, but not always&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Other cookies or similar technologies help us improve our services, measure audiences or enable advertising.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; font-size:12pt;">
        <span style="font-family:'Calibri Light'; color:#0070c0;">Your Choices</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Most web and mobile device browsers automatically accept cookies, but if you prefer, you can change your browser to prevent that or to notify you each time a cookie is set. Some browser manufacturers provide comprehensive help relating to cookie management in their products. Please see your web browser provider’s settings for more information.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >You can also learn more about cookies by visiting&nbsp;</span>
        <u>
          <span style="font-family:'Calibri Light'; color:#0563c1;">www.allaboutcookies.org</span>
        </u>
        <span
          style="font-family:'Calibri Light';"
        >, which includes additional useful information on cookies and how to block cookies using different types of browsers or mobile devices.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <em>
          <span
            style="font-family:'Calibri Light'; color:#002060;"
          >Please note, however, that by blocking or deleting all cookies used on the PFX Websites, you may not be able to take full advantage of the PFX Websites and you may not be able to properly log on to the PFX Websites.</span>
        </em>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Google Analytics</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >The PFX Websites use Google Analytics, a service that drops cookies and/or similar technologies to collect and store information about your device and use of the PFX Websites. We use Google Analytics to calculate visitor, session and campaign data for the PFX Websites analytics reports.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span style="font-family:'Calibri Light';">You can read Google’s privacy policy&nbsp;</span>
        <u>
          <span style="font-family:'Calibri Light'; color:#0000ff;">here</span>
        </u>
        <span
          style="font-family:'Calibri Light';"
        >. You can opt-out from being tracked by Google Analytics in a particular browser on a particular device by downloading and installing the Google Analytics Opt-out Browser Add-on for that browser which is available&nbsp;</span>
        <u>
          <span style="font-family:'Calibri Light'; color:#0000ff;">here</span>
        </u>
        <span style="font-family:'Calibri Light';">.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Adobe Analytics&nbsp;</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <a name="_cmntref1">
          <span
            style="font-family:'Calibri Light';"
          >The PFX Websites and/or PFX Platform may use Adobe’s analytics and on-site personalization services, which use cookies, web beacons, web pixels and/or similar technology to collect and store information about you or your device or browser, which may include non-personal information described above. Additional information regarding how Adobe may handle information collected through our use of its services, and to learn about your options for controlling this activity, can be found&nbsp;</span>
          <u>
            <span style="font-family:'Calibri Light'; color:#0000ff;">here</span>
          </u>
          <span style="font-family:'Calibri Light';">.</span>
        </a>
        <a href="#_cmnt1" style="text-decoration:none;">
          <span style="font-family:'Times New Roman'; font-size:8pt;">[CMG1]</span>
        </a>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Social Plugins</span>
      </h3>
      <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We may use social plugins on our Services and may include icons that allow you to interact with third-party social networks such as LinkedIn, Twitter and Facebook. For example, you may “like” us on Facebook or follow us on Twitter. The third-party social plugin may set a cookie when your browser creates a connection to the servers of such social networks and the plugin may transmit your personal information to the social networks. Your use of these social plugins is subject to the privacy policies of the third-party social networks.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">How We Use Your Information</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We will use your information for the purpose for which you provided it or for which we collected it.</span>
        <span style="font-family:'Calibri Light';">&nbsp;</span>
        <span style="font-family:'Calibri Light';">We may use your information to:</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Create and maintain your PFX Account and account profile, registration information and communication preferences</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Facilitate and complete any transactions, such as an auction, as part of our Services</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span style="font-family:'Calibri Light'; font-size:11pt;">Enhance user experience</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span style="font-family:'Calibri Light'; font-size:11pt;">Perform research and analytics</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Customize, personalize and deliver the content and advertising that you see on the Services and elsewhere</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Respond to and fulfill your requests for Services (including qualification to make bids or offers) or other inquiries</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Determine your eligibility for certain marketing or transaction events, services, gifts, prizes, and special features of the Services</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Call, email or otherwise contact you in order to:</span>
        </li>
      </ul>
      <ul style="margin:0pt; padding-left:0pt;" type="circle">
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Facilitate marketing or transaction events for which you are registered</span>
        </li>
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Inform you of new opportunities relating to marketing or transaction events or our other Services</span>
        </li>
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Send you information about topics that may be of interest to you</span>
        </li>
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Communicate in relation to your PFX Account</span>
        </li>
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Alert you to the latest developments and features of the Services</span>
        </li>
        <li
          style="margin-left:47pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Enable other marketing, transactional, informational or research purposes</span>
        </li>
      </ul>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Administer surveys or questionnaires, promotions, or any other services, events or activities sponsored by us or third parties, or offered in connection with our Services</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span style="font-family:'Calibri Light'; font-size:11pt;">Train you to use our software</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Enforce our Terms and other contractual rights, and protect our rights and property and the rights and property of others</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span style="font-family:'Calibri Light'; font-size:11pt;">Enable feedback</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span style="font-family:'Calibri Light'; font-size:11pt;">Comply with law.</span>
        </li>
      </ul>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Tailored Advertising</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:12pt;">
        <span
          style="font-family:'Calibri Light'; font-size:11pt;"
        >The Services may include third-party tailored ad technology, which enables customized and targeted ads to be displayed to you through the Services and on third party websites, apps and services. This is enabled, if at all, via cookies and similar technologies, as explained&nbsp;</span>
        <a href="#_Cookies" style="text-decoration:none;">
          <u>
            <span style="font-family:'Calibri Light'; font-size:11pt; color:#0000ff;">above</span>
          </u>
        </a>
        <span
          style="font-family:'Calibri Light'; font-size:11pt;"
        >. When you use the Services, we or third parties operating ad technology (“Ad Partners”) use information that is collected through cookies and similar technologies to present you with ads and to analyze your use of the Services and other websites, apps and services tracked by Ad Partners. These technologies also may help control the number of times you see a given ad, deliver ads that relate to your interests, and measure the effectiveness of ad campaigns.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light'; color:#191919;"
        >We and our Ad Partners endeavor in good faith to adhere to self-regulatory advertising principles, such as the DAA or NAI.</span>
        <span style="font-family:'Calibri Light'; color:#191919;">&nbsp;&nbsp;</span>
        <span
          style="font-family:'Calibri Light';"
        >If you are interested in learning more about and/or opting out of online behavioral advertising, sometimes called interest-based advertising, we encourage you to visit one of the advertising industry-developed opt-out pages</span>
        <span style="font-family:'Calibri Light'; color:#191919;">:</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt;"
        >
          <a href="http://optout.networkadvertising.org/?c=1#!/" style="text-decoration:none;">
            <u>
              <span
                style="font-family:'Calibri Light'; color:#0000ff;"
              >Network Advertising Initiative</span>
            </u>
          </a>
        </li>
        <li
          style="margin-left:28.06pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt;"
        >
          <a href="http://optout.aboutads.info/?c=2#!/" style="text-decoration:none;">
            <u>
              <span style="font-family:'Calibri Light'; color:#0000ff;">DAA</span>
            </u>
          </a>
        </li>
        <li
          style="margin-left:28.06pt; margin-bottom:6pt; text-align:justify; padding-left:7.94pt; font-family:serif; font-size:11pt;"
        >
          <span style="font-family:'Calibri Light';">EDAA</span>
          <span style="font-family:'Calibri Light'; color:#191919;">&nbsp;</span>
        </li>
      </ul>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If you do not want to receive tailored in-application ads that relate to your interests and are based on your mobile device’s identifier, you may opt-out by following the instructions provided by your device manufacturer.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Please note that even if you opt-out of tailored advertising, you may still receive ads, however those ads will not be tailored to your interests by participating companies.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Do Not Track Signals</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We do not respond to or alter our practices based upon your selection of the “Do Not Track” setting or other “opt out” setting or feature that may be offered by your browser, however we reserve the right to do so in the future.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Disclosure of Your Information&nbsp;</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We may share your information in the following ways:</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may make information collected through the Services available to subsidiaries and affiliated companies that are under common ownership or control within the PFX family.</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >If you download information on assets listed on our Services or make a bid or offer on a particular asset, the seller and its affiliates and representatives, and potentially other parties related to the transaction, are given access to your information.</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may share information about our visitors, customers, or former customers with the following types of companies:</span>
        </li>
      </ul>
      <ul style="margin:0pt; padding-left:0pt;" type="circle">
        <li
          style="margin-top:6pt; margin-left:47pt; margin-bottom:6pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Companies that perform services on our behalf, such as fulfillment service providers, website hosting services, payment processors, customer/support services.</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:47pt; margin-bottom:6pt; text-align:justify; padding-left:7pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >Marketing and advertising partners.</span>
        </li>
      </ul>
      <p
        style="margin-top:6pt; margin-left:36pt; margin-bottom:6pt; text-align:justify; font-size:11pt;"
      >
        <span
          style="font-family:'Calibri Light';"
        >In some cases, these third parties or service providers collect information directly from you</span>
      </p>
      <ul style="margin:0pt; padding-left:0pt;" type="disc">
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may share your information with any person or entity where we believe in good faith that such disclosure is necessary or otherwise appropriate to: (a) comply with the law or in response to a valid subpoena, court order, government request, or other valid legal process; (b) produce relevant documents or information in connection with litigation, arbitration, mediation, adjudication, government or internal investigations, or other legal or administrative proceedings; (c) protect the interests, rights, safety, or property of PFX or others; or (d) enforce the Terms for the Services or other contractual obligations.&nbsp;</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may share your information to provide other users with the services they request, such as a buyer if you are a seller.</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may transfer your personal information to a successor entity upon a merger, consolidation or other corporate reorganization in which PFX participates, or to a purchaser or acquirer of all or substantially all of PFX’s business or assets, including a successor in bankruptcy</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may share your information with any person or entity when we have your consent.</span>
        </li>
        <li
          style="margin-top:6pt; margin-left:27.6pt; margin-bottom:6pt; text-align:justify; padding-left:8.4pt; font-family:serif; font-size:10pt;"
        >
          <span
            style="font-family:'Calibri Light'; font-size:11pt;"
          >We may use and share non-personal information about you or use of the Services, including any de-identified and aggregated data with third parties without limitation.</span>
        </li>
      </ul>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span
          style="font-family:Calibri; font-weight:normal;"
        >Opting Out of Marketing Communications from Us</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >You may opt out of receiving direct marketing emails and other promotional email communications. For example, from time to time we may send you email notices or news updates alerting you to new features, products, promotions, or services pertaining to offerings from us, new opportunities, surveys or other aspects of our Services.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If you no longer wish to receive marketing communications, you may opt out by contacting us at contact@pfxinc.com or by choosing the “Unsubscribe” option available as a link in every promotional email.</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We will gladly comply with all requests to opt out of or unsubscribe from promotional communications, but reserve the maximum amount of time allowed by law to process such requests. You cannot opt out of certain transactional emails or telephone calls, which are necessary to conclude a transaction.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Security And Account Protection</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We have implemented commercially reasonable physical, administrative, technical, and electronic security measures designed to protect against the loss, misuse, and alteration of your personal information. Despite our efforts, however, no security measures are perfect or impenetrable, and we do not promise that your information will remain secure.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We appreciate your help in safeguarding the integrity of your own and others’ privacy. We encourage you to let us know immediately if you suspect that any personal information you shared with us is being used contrary to this Privacy Notice.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Children’s Information</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >The Services are not directed toward persons under eighteen (18) years of age. We do not knowingly market to or collect any personal information from children under the age of eighteen (18). If you are under eighteen (18), you are not permitted to submit any personal information to us or the Services</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If you are a parent or guardian, and believe that we have the personal information of your minor child</span>
        <span style="font-family:'Calibri Light';">&nbsp;&nbsp;</span>
        <span
          style="font-family:'Calibri Light';"
        >in our database, please contact us immediately at contact@pfxinc.com to request that we remove such information from our records.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Updating Personal Information</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >If personal information you provided changes or is inaccurate, you agree to update your information by updating the account information located in your PFX Account profile. If you are unable to do so, or if you no longer wish to use the Services, please contact us directly at contact@pfxinc.com.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Third Party Links and Services</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >The Services may contain links to third-party websites, including identity verification and social networking websites. Your use of these features may result in the collection or sharing of information about you, depending on the feature. Please be aware that we are not responsible for the content or privacy practices of other websites or services, including those to which we link. We do not endorse or make any representations about third-party websites or services. The personal information you choose to provide to or that is collected by these third parties is not covered by our Privacy Notice. We strongly encourage you to read such third parties’ Privacy Notices.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">International Transfers&nbsp;</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >We are located in the United States, and the personal information that we collect is stored on servers located in the United States. This means that your personal information will be collected, processed and stored in the United States, which may have data protection laws that are different from (and sometimes less protective than) the laws of your country or region.&nbsp;</span>
      </p>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >By sending us personal information, you agree and consent to the processing of your personal information in the United States, which may not offer an equivalent level of protection to that required in other countries (particularly the European Union), and to the processing of that information by us on servers located in the United States, as described in this Privacy Notice.</span>
      </p>
      <h3 style="margin-top:6pt; margin-bottom:6pt; page-break-after:avoid; font-size:14pt;">
        <span style="font-family:Calibri; font-weight:normal;">Contacting Us</span>
      </h3>
      <p style="margin-top:6pt; margin-bottom:6pt; text-align:justify; font-size:11pt;">
        <span
          style="font-family:'Calibri Light';"
        >Should you have any questions about this Privacy Notice, contact us by sending an email to contact@pfxinc.com. Please provide your name, mailing address, telephone number and email address so we can service you more quickly. You can also call us at 855-949-3800&nbsp;</span>
        <span style="font-family:'Calibri Light';">&nbsp;</span>
        <span
          style="font-family:'Calibri Light';"
        >or write to us at PFX Inc., 1111 North Brand Boulevard, Suite 200, Glendale, California 91202.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:11pt;">
        <span style="font-family:'Calibri Light';">&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt;">
        <span style="font-family:'Times New Roman';">&nbsp;</span>
      </p>
    </div>

    <div v-else-if="contentToShow === 'broker'">
      <h1>Broker Registration Terms</h1>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12pt; background-color:#ffffff;"
      >
        <strong>
          <span style="font-family:Calibri; text-transform:uppercase;">PFX Broker Registration Terms</span>
        </strong>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12pt; background-color:#ffffff;"
      >
        <strong>
          <em>
            <span
              style="font-family:Calibri;"
            >This Broker Registration Terms was last updated February 17, 2020</span>
          </em>
        </strong>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12pt; background-color:#ffffff;"
      >
        <strong>
          <span style="font-family:Calibri; text-transform:uppercase;">&nbsp;</span>
        </strong>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <a name="_Hlk512440475"></a>
        <a name="_cmntref1">
          <strong>
            <span style="font-family:Calibri;">IMPORTANT&nbsp;</span>
          </strong>
        </a>
        <strong>
          <span
            style="font-family:Calibri;"
          >– PLEASE CAREFULLY READ THESE BROKER REGISTRATION TERMS.</span>
        </strong>
        <strong>
          <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        </strong>
        <strong>
          <span
            style="font-family:Calibri;"
          >BY CLICKING ON THE “I AGREE” BUTTON, (1) YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND BY THESE BROKER TERMS, THE TERMS, PRIVACY STATEMENT, EVENT T&amp;CS, AND ANY ADDITIONAL TERMS, (2) YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO ENTER INTO THIS AGREEMENT (INCLUDING ALL OF THE TERMS AND CONDITIONS SPECIFIED OR REFERENCED BELOW), ON BEHALF OF BROKER, AND TO BIND BROKER TO THESE BROKER TERMS, AND (3) YOU AGREE THAT BROKER IS ENTERING INTO THESE TERMS WITH PFX INC.</span>
        </strong>
        <strong>
          <span
            style="font-family:Calibri;"
          >IF YOU DO NOT AGREE TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, OR IF YOU DO NOT HAVE SUCH AUTHORITY, YOU SHOULD CLICK ON THE “CANCEL” BUTTON AND DISCONTINUE THE REGISTRATION PROCESS.</span>
        </strong>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <strong>
          <span style="font-family:Calibri;">&nbsp;</span>
        </strong>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">These Broker Registration Terms (“</span>
        <strong>
          <span style="font-family:Calibri;">Broker Terms</span>
        </strong>
        <span style="font-family:Calibri;">”) apply to any brokers and/or agents (“</span>
        <strong>
          <span style="font-family:Calibri;">Broker</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) participating in any auction or transaction event (each, an “</span>
        <strong>
          <span style="font-family:Calibri;">Event</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) conducted by PFX, and/or their affiliates (collectively, “</span>
        <strong>
          <span style="font-family:Calibri;">PFX</span>
        </strong>
        <span style="font-family:Calibri;">”) on behalf of a seller (each, a “</span>
        <strong>
          <span style="font-family:Calibri;">Seller</span>
        </strong>
        <span style="font-family:Calibri;">”) of real property or secured note(s) (each, a “</span>
        <strong>
          <span style="font-family:Calibri;">Property</span>
        </strong>
        <span style="font-family:Calibri;">”, and collectively, “</span>
        <strong>
          <span style="font-family:Calibri;">Properties</span>
        </strong>
        <span style="font-family:Calibri;">”) on or through PFX’s proprietary online platform (the “</span>
        <strong>
          <span style="font-family:Calibri;">PFX</span>
        </strong>
        <span style="font-family:Calibri;">&nbsp;</span>
        <strong>
          <span style="font-family:Calibri;">Platform</span>
        </strong>
        <span style="font-family:Calibri;">
          ”) or the PFX website(s) located at
          <span class="c11">
            <a
              class="c27"
              href="https://www.google.com/url?q=http://www.pfxinc.com&amp;sa=D&amp;ust=1543503233956000"
            >www.pfxinc.com</a>
          </span>
        </span>
        <span style="font-family:Calibri;">&nbsp;(“</span>
        <strong>
          <span style="font-family:Calibri;">PFX Websites</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). As used in these Broker Terms, each prospective buyer who participates in any Event is a “</span>
        <strong>
          <span style="font-family:Calibri;">Buyer</span>
        </strong>
        <span style="font-family:Calibri;">”.</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">
          These Broker Terms are a part of and incorporated into PFX’s Terms of Use located at
          <span
            class="c11"
          >
            <a
              class="c27"
              href="https://www.google.com/url?q=http://www.pfxinc.com/terms&amp;sa=D&amp;ust=1543503233956000"
            >www.pfxinc.com/terms</a>
          </span>
        </span>
        <span style="font-family:Calibri;">(the “</span>
        <strong>
          <span style="font-family:Calibri;">Terms</span>
        </strong>
        <span style="font-family:Calibri;">”).</span>
        <span
          style="font-family:Calibri;"
        >If any provision of these Broker Terms is inconsistent or conflicts with any provision in the Terms, these Broker Terms will control solely with respect to the subject matter hereof.</span>
        <span style="font-family:Calibri;">&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >&nbsp;Capitalized terms used in these Broker Terms but not otherwise defined herein shall have the meanings given to such terms in the Terms or Event T&amp;Cs.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span style="font-family:Calibri;">
          PFX’s collection and use of any information collected by PFX in connection with the participation in any Event shall be subject to and in accordance with PFX’s Privacy Statement available at
          <span
            class="c11"
          >
            <a
              class="c27"
              href="https://www.google.com/url?q=http://www.pfxinc.com/privacy&amp;sa=D&amp;ust=1543503233956000"
            >www.pfxinc.com/privacy</a>
          </span>&nbsp;
        </span>
        <span style="font-family:Calibri;">.</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <ol style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; text-transform:uppercase; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:3.71pt;"
        >
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <u>Registration</u>
          <u>&nbsp;&nbsp;</u>
        </li>
      </ol>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span
          style="font-family:Calibri;"
        >In order to receive any available commission or referral fee Broker must have completed registration</span>
        <a name="_cmntref3"></a>
        <span
          style="font-family:Calibri;"
        >, or otherwise been identified by Buyer in writing to PFX as the Buyer's representing or referring broker, at or prior to the applicable registration deadlines (“</span>
        <strong>
          <span style="font-family:Calibri;">Broker Registration Deadline</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) set forth below, and provide the following information:</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <div style="margin-left:18pt; background-color:#ffffff;">
        <p
          style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-indent:-18pt; text-align:justify; font-size:12pt;"
        >
          <span style="font-family:Calibri;">(a)</span>
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-family:Calibri;"
          >Broker must complete an IRS Form W-9 with the Broker’s information;</span>
        </p>
      </div>
      <div style="margin-left:18pt; background-color:#ffffff;">
        <p
          style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-indent:-18pt; text-align:justify; font-size:12pt;"
        >
          <span style="font-family:Calibri;">(b)</span>
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-family:Calibri;"
          >The Buyer must identify Broker as the Buyer's representing or referring broker; and</span>
        </p>
      </div>
      <div style="margin-left:18pt; background-color:#ffffff;">
        <p
          style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-indent:-18pt; text-align:justify; font-size:12pt;"
        >
          <span style="font-family:Calibri;">(c)</span>
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Calibri;">The Buyer must close on the purchase of the Property.</span>
        </p>
      </div>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <ol start="2" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; text-transform:uppercase; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:3.71pt;"
        >
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <u>Broker Registration Deadlines&nbsp;</u>
        </li>
      </ol>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span
          style="font-family:Calibri;"
        >For Events, the Broker Registration Deadline is the later of the time the Buyer registers for the Property, or the end of the Buyer Registration Period as identified for the Event.</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <ol start="3" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; text-transform:uppercase; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:3.71pt;"
        >
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <u>Commissions</u>
        </li>
      </ol>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span
          style="font-family:Calibri;"
        >Cooperating Broker commissions are based on the purchase price (excluding any transaction fee) and are paid pursuant to the terms identified in the purchase agreement. It is Broker’s responsibility to comply with all laws and regulations applicable to its representation or referral of the Buyer. Please note that if Broker is licensed in a state other than where the Property is located, Broker may be eligible to receive a referral fee, but state laws may prohibit Broker from providing brokerage services in the transaction.</span>
      </p>
      <ol start="4" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; text-transform:uppercase; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:3.71pt;"
        >
          <span style="font:7pt 'Times New Roman';">&nbsp;&nbsp;&nbsp;</span>
          <u>Electronic Acceptance</u>
        </li>
      </ol>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span
          style="font-family:Calibri;"
        >Broker acknowledges that it is executing this Agreement by accepting the terms by hitting the "ACCEPT" button. Broker acknowledges that such form of acceptance shall be binding and enforceable pursuant to Electronic Signatures in Global and National Commerce Act ("</span>
        <strong>
          <span style="font-family:Calibri;">E-Sign Act</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >"), Title 15, United States Code, Sections 7001 et seq., the Uniform Electronic Transaction Act ("</span>
        <strong>
          <span style="font-family:Calibri;">UETA</span>
        </strong>
        <span style="font-family:Calibri;">"), and applicable state laws.</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt; background-color:#ffffff;"
      >
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10pt; line-height:115%; font-size:11pt;">
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
    </div>

    <div v-else-if="contentToShow === 'terms'">
      <h1>Website Terms of Use</h1>

      <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12pt;">
        <strong>
          <span
            style="font-family:Calibri; font-variant:small-caps;"
          >PFX EVENT PARTICIPATION TERMS &amp; CONDITIONS</span>
        </strong>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:center; font-size:12pt;">
        <strong>
          <em>
            <span style="font-family:Calibri;">Last updated March, 2019</span>
          </em>
        </strong>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <a name="_gjdgxs"></a>
        <span style="font-family:Calibri;">These Event Participation Terms and Conditions (“</span>
        <strong>
          <span style="font-family:Calibri;">Event T&amp;Cs</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) apply to each auction or other transaction event (each, an “</span>
        <strong>
          <span style="font-family:Calibri;">Event</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) conducted by PFX, and/or their affiliates (collectively, “</span>
        <strong>
          <span style="font-family:Calibri;">PFX</span>
        </strong>
        <span style="font-family:Calibri;">”) on behalf of a seller (each, a “</span>
        <strong>
          <span style="font-family:Calibri;">Seller</span>
        </strong>
        <span style="font-family:Calibri;">”) of real property or secured note(s) (each, a “</span>
        <strong>
          <span style="font-family:Calibri;">Property</span>
        </strong>
        <span style="font-family:Calibri;">”, and collectively, “</span>
        <strong>
          <span style="font-family:Calibri;">Properties</span>
        </strong>
        <span style="font-family:Calibri;">”) on or through PFX’s proprietary online platform (the “</span>
        <strong>
          <span style="font-family:Calibri;">PFX</span>
        </strong>
        <span style="font-family:Calibri;">&nbsp;</span>
        <strong>
          <span style="font-family:Calibri;">Platform</span>
        </strong>
        <span style="font-family:Calibri;">”) or the PFX website(s) located at&nbsp;</span>
        <a href="https://www.pfxinc.com" style="text-decoration:none;">
          <u>
            <span style="font-family:Calibri; color:#0000ff;">https://www.pfxinc.com</span>
          </u>
        </a>
        <span style="font-family:Calibri;">&nbsp;(“</span>
        <strong>
          <span style="font-family:Calibri;">PFX Website</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). As used in these Event T&amp;Cs, each prospective buyer who participates in any Event is a “</span>
        <strong>
          <span style="font-family:Calibri;">Participant</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”. As used in these Event T&amp;Cs, the terms “PFX”, “Seller” and “Participant” shall also refer to the respective principals, agents, and affiliates of each party. “</span>
        <strong>
          <span style="font-family:Calibri;">Winning Buyer</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >” is the Participant that (a) submits the highest net bid in an auction Event and is acknowledged by PFX by email or telephone as the winning bidder, or (b) submits any offer during any Event that is accepted by Seller. As used in these Event T&amp;Cs, each bid or offer submitted in any Event is an “</span>
        <strong>
          <span style="font-family:Calibri;">Offer</span>
        </strong>
        <span style="font-family:Calibri;">”.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >PFX conducts Events solely on behalf of Seller, and is not acting as an agent for any Participant in any capacity.&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <a name="_30j0zll"></a>
        <span
          style="font-family:Calibri;"
        >These Event T&amp;Cs are a part of and incorporated into PFX’s Terms of Use located at&nbsp;</span>
        <a href="https://pfxinc.co/terms" style="text-decoration:none;">
          <u>
            <span style="font-family:Calibri; color:#1155cc;">https://pfxinc.com/terms</span>
          </u>
        </a>
        <span style="font-family:Calibri;">&nbsp;(the “</span>
        <strong>
          <span style="font-family:Calibri;">Terms</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). If any provision of these Event T&amp;Cs is inconsistent or conflicts with any provision in the Terms, these Event T&amp;Cs will control solely with respect to the subject matter hereof.</span>
        <span style="font-family:Calibri;">&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >&nbsp;Capitalized terms used in these Event T&amp;Cs but not otherwise defined herein shall have the meanings given to such terms in the Terms.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >PFX’s collection and use of any information collected by PFX in connection with the participation in any Event shall be subject to and in accordance with PFX’s Privacy Statement available at&nbsp;</span>
        <a href="https://pfxinc.co/privacy" style="text-decoration:none;">
          <u>
            <span style="font-family:Calibri; color:#1155cc;">https://pfxinc.com/privacy</span>
          </u>
        </a>
        <span style="font-family:Calibri;">.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <span
          style="font-family:Calibri;"
        >By registering for an Event or submitting an Offer on or through the PFX Websites or PFX Platform (collectively, the “</span>
        <strong>
          <span style="font-family:Calibri;">Service</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”), Participant acknowledges having read and accepted these T&amp;Cs, the Terms, and the Privacy Statement. By submitting an Offer on a Property, Participant is deemed to have accepted any additional terms and conditions posted on the Property’s details page within the Service (“</span>
        <strong>
          <span style="font-family:Calibri;">Property Page</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) at the time the Offer was submitted, and such terms and conditions shall govern and control over these Event T&amp;Cs to the extent of any conflict.&nbsp;</span>
      </p>
      <ol style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <a name="_1fob9te"></a>ACCOUNT CREATION AND REGISTRATION PROCESS
        </li>
      </ol>
      <p
        style="margin-top:0pt; margin-left:36pt; margin-bottom:12pt; text-indent:-36pt; text-align:justify; font-size:12pt;"
      >
        <u>
          <span style="font-family:Calibri;">PFX Account</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span style="font-family:Calibri;">Participants must create a PFX account (“</span>
        <strong>
          <span style="font-family:Calibri;">PFX Account</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) through the PFX Platform or PFX Website in order to participate in any Event.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Event-level Registration</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >Some Events may also require Event-level registration and, as part of that registration process, Participants may be required to place a deposit to secure compliance with these Event T&amp;Cs (“</span>
        <strong>
          <span style="font-family:Calibri;">Participation Deposit</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). The amount of the Participation Deposit (if any) and acceptable deposit methods will be shown during registration. Winning Buyer’s Participation Deposit (if any) may be applied towards the required “Earnest Money Deposit” (defined below), unless the Participation Deposit was made by a credit card hold, in which case such hold will be released after confirmation that the “Purchase Documents” (defined below) have been fully signed and the Earnest Money Deposit has been timely received. All Participation Deposits from Participants other than Winning Buyer will be released after the Event.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Additional Requirements; Modifications</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. PFX may modify, waive, or impose additional participation requirements for certain Properties or Participants in its sole and absolute discretion or at the request of Seller.</span>
      </p>
      <ol start="2" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>DUE DILIGENCE
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Purchase Documents</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Prior to submitting an Offer, Participants must review the purchase and sale agreement, any applicable addenda, Seller’s disclosure documentation, and all other transaction documents (collectively, “</span>
        <strong>
          <span style="font-family:Calibri;">Purchase Documents</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”), which can be accessed on the Property Page. All Offers must be based on the posted Purchase Documents. For auction Events, the Purchase Documents are non-negotiable. For non-auction Events, all negotiable terms agreed to by both Seller and Winning Buyer shall be incorporated into the final Purchase Documents using the applicable blanks and checkboxes in the pre-printed provisions in the Purchase Documents.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Due Diligence</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. It is each Participant’s responsibility to conduct its own due diligence and investigate all matters relating to each Property that Participant is interested in purchasing, including, without limitation, legal matters, physical condition and attributes, environmental matters, economic matters, encumbrances, and all other aspects. Participant must coordinate any such inspection with Seller. In some circumstances Seller may be unable to provide physical access for inspections, and Participants must submit Offers accordingly at their own risk. All Offers should be based solely on Participant’s independent due diligence and any information contained in the Purchase Documents.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >Property information has been gathered from a variety of sources and has not been independently verified by PFX.&nbsp;</span>
        <strong>
          <span
            style="font-family:Calibri;"
          >Participants are encouraged to consult with a licensed real estate broker, contractor, attorney, financial advisor, tax advisor, and/or other relevant professionals</span>
        </strong>
        <span style="font-family:Calibri;">.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Participant Inspections/Investigations</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Participant is responsible for all liability, damages and/or costs directly or indirectly arising from Participant’s inspection, visit, or investigation of the Property. Participant agrees to indemnify, defend and hold harmless Seller and PFX from any such liability, damages and/or costs, and to maintain all applicable policies of insurance insuring over such liability, damages and/or costs.</span>
      </p>
      <ol start="3" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>BUYING
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Irrevocability of Offers</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. All Offers submitted during any Event are irrevocable, except where an Offer withdrawal option is expressly made available to Participants through the Service.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Signing Purchase Documents</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. The final Purchase Documents will be emailed to Winning Buyer for electronic signature using the email address associated with Winning Buyer’s PFX Account. Winning Buyer must sign the Purchase Documents within twenty-four hours after they are sent to Winning Buyer (unless a longer timeframe is specified in writing by PFX), time being of the essence. If Winning Buyer fails to timely sign the Purchase Documents, PFX or Seller may declare Winning Buyer to be in default of these Event T&amp;Cs and Seller may reject Winning Buyer’s Offer.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Payment of Earnest Money Deposit</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. The Purchase Documents for each Property require Winning Buyer to pay a deposit to the escrow/closing agent (“</span>
        <strong>
          <span style="font-family:Calibri;">Earnest Money Deposit</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). The amount of the Earnest Money Deposit is specified in the Purchase Documents or the Property Page for each Property. Unless otherwise specified in the Purchase Documents, the Earnest Money Deposit must be received no later than 5:00 PM in the time zone where the Property is located by the second business day after Winning Buyer is notified that Seller has countersigned the Purchase Documents, time being of the essence. If the Earnest Money Deposit is not timely received, PFX or Seller may declare Winning Buyer to be in default of these Event T&amp;Cs and Seller may reject Winning Buyer’s Offer.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Proof of Funds and Additional Information</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. PFX or Seller may require Participants to provide proof of readily available funds and/or additional information at any time prior to registration approval, submission of an Offer, and/or acceptance of an Offer. If PFX or Seller requires Winning Buyer to provide proof of funds or additional information and such proof of funds or additional information is not timely received, PFX or Seller may reject Winning Buyer’s Offer.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Entity Buyers</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Winning Buyers wanting to take title in the name of an entity (not as an individual) may be required to provide entity formation documents and resolutions authorizing the purchase within the timeframe specified by PFX (which may be before or after the Event, in PFX’s sole discretion). Seller and/or the escrow/closing agent may require additional documentation prior to closing.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Buyer’s Fee</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. If the Property Page for a Property states that a buyer’s premium or transaction fee (“</span>
        <strong>
          <span style="font-family:Calibri;">Buyer’s Fee</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) applies to the sale, then Winning Buyer will be required to pay the Buyer’s Fee in addition to Winning Buyer’s Offer amount at closing. Unless otherwise specified for a particular Property, the Buyer’s Fee will be added to Winning Buyer’s Offer amount to establish the total purchase price payable by Winning Buyer. If the Property is anything other than a one to four unit residential property and Participant purchases it from the Seller outside of PFX’s platform within 180 days after the date Participant acknowledges these Event T&amp;Cs, Participant agrees to be responsible to PFX for full payment of the Buyer’s Fee that would have been payable if Participant had purchased the Property through PFX’s platform.&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Short Sale Properties</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Some Properties involve a sale in which the proceeds may fall short of the balance of debts secured by the Property (“</span>
        <strong>
          <span style="font-family:Calibri;">Short Sale</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). All Offers for Short Sale Properties are subject to the approval of the applicable lien holders (“</span>
        <strong>
          <span style="font-family:Calibri;">Short Sale Lender’s Consent</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). If Short Sale Lender’s Consent is not received, the transaction will be cancelled and the Earnest Money Deposit will be returned to Participant.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Auto-bid.</span>
        </u>
        <span
          style="font-family:Calibri;"
        >&nbsp;The Auto-bid function allows Buyers to bid on a Property by specifying the incremental amount above the previously recorded bid which the Buyer is willing to pay</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span style="font-family:Calibri;">(“</span>
        <strong>
          <span style="font-family:Calibri;">Bid Increment</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) and a maximum price that the Buyer is willing to pay for the Property (“</span>
        <strong>
          <span style="font-family:Calibri;">Maximum Price</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). The Auto-bid function will automatically place bids for the Buyer until such time as the Buyer is either (i) the highest bidder or (ii) the Buyer’s Maximum Price is reached. The Buyer may change the Auto-bid parameters at any time during the auction or eliminate the Auto-bid function and actively bid during the live auction.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <span
          style="font-family:Calibri;"
        >The first Auto-bid will be placed by the Buyer that (i) is the first Buyer accepted to bid on the Property and (ii) has selected the Auto-bid function (collectively, the first “</span>
        <strong>
          <span style="font-family:Calibri;">Auto-bid Buyer</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). Subsequent Auto-bids, if any, will be placed according to the order in which the respective Auto-Bid Buyers were approved to bid on the Property.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <span
          style="font-family:Calibri;"
        >In the event there are no more live bids placed and there are multiple Auto-bid Buyers with the same Maximum Price, the Auto-bid Buyer with the highest Bid Increment will win. In the event there are no more live bids placed and there are multiple Auto-bid Buyers with the same Maximum Price and Bid Increment, the first Auto-bid Buyer will win.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <span
          style="font-family:Calibri;"
        >Auto-bids will be placed upon commencement of the live auction, in their prescribed order and within a time period specified by PFX.&nbsp;</span>
      </p>
      <ol start="4" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>AUCTION EVENTS
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Reserve Price</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Except for Properties noted “Absolute Auction” or “Minimum Bid Auction”, all Properties in auction Events have a minimum selling price established by Seller (“</span>
        <strong>
          <span style="font-family:Calibri;">Reserve Price</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”). The starting bid is not the Reserve Price. Except where prohibited by law, PFX may counter bid on behalf of Seller on any Property up to the amount of the Reserve Price (and no such bid will result in a sale of the Property). If the Reserve Price is not met, Seller is under no obligation to sell the Property; however, Seller may accept a bid that is below the Reserve Price in its sole and absolute discretion.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Minimum Bid Auction Events</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Properties to be auctioned without a Reserve Price but with a minimum bid will be listed in a “Minimum Bid Auction” and will be sold to the highest bidder at or above the minimum bid amount.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Absolute Auction Events</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Properties to be auctioned without a Reserve Price or minimum bid will be listed in an “Absolute Auction” and will be sold to the highest bidder.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Extension of Auction Time</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. In order to allow final bids to be properly input and processed during auction Events, PFX may extend the time for bidding on any Property in its sole and absolute discretion to allow for additional bids.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Subject to Confirmation</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Seller may designate certain Offers as “Subject To Confirmation” in its sole and absolute discretion, in which case Winning Buyer’s purchase is subject to, and contingent upon, Seller approving the purchase in its sole and absolute discretion within the time period set forth in the Purchase Documents. Winning Buyer will receive a refund of monies deposited if Seller chooses not to approve the purchase.</span>
      </p>
      <ol start="5" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>BROKER/AGENT PARTICIPATION
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Broker/Agent Participation</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. We encourage real estate brokers and agent participation. A cooperating broker commission or referral fee may be offered for some Properties. Please see the applicable Property Page for details regarding broker/agent participation and cooperating broker commissions or referral fees related to a specific Property.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Broker Registration</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >Participation as a broker or agent in any Event is conditioned on such broker or agent registering with the PFX Platform and/or PFX Website and agreeing to be bound by the Broker Registration Terms available at&nbsp;</span>
        <a href="https://pfxinc.com/broker" style="text-decoration:none;">
          <u>
            <span style="font-family:Calibri; color:#1155cc;">https://pfxinc.com/broker</span>
          </u>
        </a>
        <span
          style="font-family:Calibri;"
        >. The Broker Registration Terms are a part of and are incorporated into these Event T&amp;Cs.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Submitting Offers</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >For certain Events, a registered broker/agent may submit Offers on behalf of a buyer identified to PFX prior to Offer submission. By submitting an Offer on behalf of a buyer, the broker/agent (i) represents and warrants that the broker/agent has received all buyer authorizations and satisfied all legal requirements necessary to submit Offers on the buyer’s behalf, (ii) acknowledges and agrees that any Offer submitted will be binding upon the broker/agent and the buyer identified at registration to the same extent as if the buyer had submitted the Offer, and (iii) agrees to indemnify and hold harmless PFX from any breach of these representations or warranties, these Event T&amp;Cs or the Broker Registration Terms.</span>
      </p>
      <ol start="6" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>DISCLAIMERS; LIMITATION OF LIABILITY; CANCELLATION; LIQUIDATED DAMAGES
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">DISCLAIMER</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >PFX MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND OR CHARACTER WHATSOEVER, WHETHER EXPRESS OR IMPLIED, WITH RESPECT TO ANY PROPERTY, OR THE LEGAL SUFFICIENCY OR TAX CONSEQUENCES OF ANY DOCUMENT PROVIDED BY PFX.&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">LIMITATION OF LIABILITY</span>
        </u>
        <span style="font-family:Calibri;">.&nbsp;</span>
        <span
          style="font-family:Calibri; font-variant:small-caps;"
        >TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL PFX BE LIABLE, UNDER ANY CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHER THEORY, FOR ANY SPECIAL, PUNITIVE, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES, OR FOR ANY LOSS OF OR DAMAGE TO DATA, COST OF COVER, LOSS OF ANTICIPATED REVENUE OR PROFITS, OR IMPAIRMENT OF OTHER ASSETS, ARISING FROM OR IN CONNECTION WITH THESE EVENT T&amp;CS OR PFX’S PERFORMANCE HEREUNDER OR OTHER MATERIALS OR SERVICES PROVIDED HEREUNDER BY PFX, WHETHER OR NOT FORESEEABLE AND WHETHER OR NOT PFX HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</span>
        <span style="font-family:Calibri; font-variant:small-caps;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri; font-variant:small-caps;"
        >TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL PFX’S TOTAL CUMULATIVE LIABILITY ARISING FROM OR IN CONNECTION WITH THESE EVENT T&amp;CS AND OTHER MATERIALS OR SERVICES PROVIDED HEREUNDER BY PFX, UNDER ANY CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHER THEORY, EXCEED THE GREATER OF (I) TOTAL FEES ACTUALLY PAID TO PFX BY PARTICIPANT UNDER THESE T&amp;CS AND LIMITED TO THE AMOUNT OF SUCH FEE CORRESPONDING TO THE THREE (3) MONTH PERIOD IMMEDIATELY PRECEDING THE DATE THE FIRST CLAIM GIVING RISE TO SUCH LIABILITY AROSE, OR (II) IF NO FEES HAVE BEEN PAID BY PARTICIPANT TO PFX, TEN THOUSAND DOLLARS ($10,000.00).</span>
        <span style="font-family:Calibri; font-variant:small-caps;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri; font-variant:small-caps;"
        >PARTICIPANT AGREES THAT PFX SUPPLIERS AND AFFILIATES WILL HAVE NO LIABILITY OF ANY KIND UNDER OR AS A RESULT OF THESE EVENT T&amp;CS.</span>
        <span style="font-family:Calibri; font-variant:small-caps;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri; font-variant:small-caps;"
        >THE FOREGOING LIMITATIONS OF LIABILITY ARE INDEPENDENT OF ANY EXCLUSIVE REMEDIES SET FORTH IN THESE T&amp;CS.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <a name="_3znysh7"></a>
        <u>
          <span style="font-family:Calibri;">RELEASE</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >EACH PARTICIPANT HEREBY RELEASES PFX AND ITS EMPLOYEES, OFFICERS, DIRECTORS, REPRESENTATIVES, ATTORNEYS, BROKERS AND AGENTS (COLLECTIVELY, “</span>
        <strong>
          <span style="font-family:Calibri;">REPRESENTATIVES</span>
        </strong>
        <span
          style="font-family:Calibri;"
        >”) FROM ANY AND ALL CLAIMS THAT ANY SUCH PARTICIPANT MAY NOW HAVE OR HEREAFTER ACQUIRE AGAINST PFX OR ANY OF ITS REPRESENTATIVES FOR ANY DAMAGE OR INJURY RESULTING FROM OR RELATING TO ANY ERRORS, OMISSIONS OR OTHER CONDITIONS AFFECTING ANY PROPERTY, THE DOCUMENTS USED IN EVALUATING OR ACQUIRING ANY PROPERTY, OR THE CONDUCTING OF ANY EVENT. THIS RELEASE INCLUDES CLAIMS OF WHICH PARTICIPANT IS PRESENTLY UNAWARE OR DOES NOT PRESENTLY SUSPECT TO EXIST IN PARTICIPANT’S FAVOR WHICH, IF KNOWN BY PARTICIPANT, WOULD MATERIALLY AFFECT PARTICIPANT’S RELEASE OF PFX. EACH PARTICIPANT SPECIFICALLY WAIVES THE PROVISIONS OF CALIFORNIA CIVIL CODE SECTION 1542 (AND OTHER SUBSTANTIALLY SIMILAR APPLICABLE STATE STATUTES) WHICH PROVIDES AS FOLLOWS:&nbsp;</span>
        <strong>
          <span
            style="font-family:Calibri;"
          >A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR</span>
        </strong>
        <span style="font-family:Calibri;">.&nbsp;</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <strong>
          <u>
            <span style="font-family:Calibri;">CANCELLATION; LIQUIDATED DAMAGES</span>
          </u>
        </strong>
        <strong>
          <span style="font-family:Calibri;">. IF WINNING BUYER BREACHES THESE&nbsp;</span>
        </strong>
        <strong>
          <span style="font-family:Calibri; font-variant:small-caps;">EVENT T&amp;CS</span>
        </strong>
        <strong>
          <span
            style="font-family:Calibri;"
          >, WINNING BUYER’S OFFER MAY BE REJECTED BY PFX AND/OR SELLER, THE PROPERTY MAY BE IMMEDIATELY SOLD TO ANOTHER PARTICIPANT OR PLACED IN ANOTHER EVENT, AND WINNING BUYER WILL BE RESPONSIBLE FOR PAYING PFX LIQUIDATED DAMAGES IN AN AMOUNT EQUAL TO (A) THE AMOUNT OF THE PARTICIPATION DEPOSIT SHOWN AT THE TIME OF REGISTRATION (WHETHER OR NOT WINNING BUYER ACTUALLY MADE SUCH PARTICIPATION DEPOSIT), OR (B) IF NO PARTICIPATION DEPOSIT WAS SHOWN AT THE TIME OF REGISTRATION, 2% OF WINNING BUYER’S OFFER FOR THE PROPERTY. IF WINNING BUYER MADE A PARTICIPATION DEPOSIT BY CREDIT CARD HOLD, PFX IS AUTHORIZED TO CHARGE THE CREDIT CARD IN THE AMOUNT OF SUCH HOLD TO SATISFY ALL OR PART OF THE LIQUIDATED DAMAGES OWED BY WINNING BUYER. WINNING BUYER ACKNOWLEDGES THAT THE ACTUAL DAMAGES RESULTING FROM WINNING BUYER’S BREACH OF THESE&nbsp;</span>
        </strong>
        <strong>
          <span style="font-family:Calibri; font-variant:small-caps;">EVENT T&amp;CS</span>
        </strong>
        <span style="font-family:Calibri;">&nbsp;</span>
        <strong>
          <span
            style="font-family:Calibri;"
          >WOULD BE DIFFICULT AND IMPRACTICAL TO CALCULATE, AND THAT THE LIQUIDATED DAMAGES AMOUNT SET FORTH HEREIN IS A REASONABLE PRE-ESTIMATE OF THE RESULTING DAMAGES TO PFX AND IS NOT A PENALTY OR FORFEITURE.</span>
        </strong>
      </p>
      <ol start="7" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>GENERAL INFORMATION
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Additional Conditions</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. Seller and PFX reserve the right to deny, limit, or impose conditions on submitting Offers and/or access to the Service or any Event at any time, for any reason (including, without limitation, Participant’s solvency, credit history, transaction history, and Participation Deposit amounts).</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Postponement/Cancellation of Event</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. PFX may postpone or cancel an Event, rearrange the order or sequence of the Properties in the Event, modify these Event T&amp;Cs by posting notice of modification on the Property Page, remove any Property from the Event, or reject any or all Offers.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Publicity</span>
        </u>
        <span
          style="font-family:Calibri;"
        >. PFX, Sellers and/or their agents may issue press releases and other public communications regarding the Event and/or any Property offered or sold during at an Event.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Governing Law</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >These Event T&amp;Cs and the conduct of each Event shall be governed by the laws of California except in the case of auction Events involving real property located in California. With respect to auction Events involving real property located in California, these Event T&amp;Cs and the conduct of each Event shall be governed by the laws of California.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:10.5pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Property Information</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >Any information on any website, in any brochure, e-mail or postcard and any and all information available regarding the Properties shall not constitute an offer to sell or a solicitation of any offer to buy any of the Properties. Offers submitted or solicitations made during any Event are void where prohibited by law. If any sale would require registration or qualification under applicable state securities laws, no such sale may be consummated until such applicable requirements have been met.</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; font-size:12pt;">
        <u>
          <span style="font-family:Calibri;">Obligations Non-Binding</span>
        </u>
        <span style="font-family:Calibri;">.</span>
        <span style="font-family:Calibri;">&nbsp;&nbsp;</span>
        <span
          style="font-family:Calibri;"
        >As between Seller and Participant, no obligation to sell shall be binding on Seller unless and until the Purchase Documents have been signed and delivered by Seller and the Earnest Money Deposit has been received as required hereunder. After the Purchase Documents have been fully signed, the Purchase Documents shall govern the relationship between Winning Buyer and Seller.&nbsp;</span>
      </p>
      <ol start="8" style="margin:0pt; padding-left:0pt;" type="1">
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>MISCELLANEOUS.&nbsp;
          <span
            style="font-weight:normal;"
          >Neither the rights nor the obligations arising under these Event T&amp;Cs are assignable by Participant, and any such attempted assignment or transfer shall be void and without effect.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >Any waiver, amendment or modification of any provision of these Event T&amp;Cs must be in writing and executed by both parties.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >The failure of either party to exercise any right provided for by these Event T&amp;Cs shall not be deemed a waiver of that right.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >Each party represents and warrants to the other that the execution and delivery of these Event T&amp;Cs and the performance of such party’s obligations have been duly authorized and that these Event T&amp;Cs is a valid and legal agreement binding on the party and enforceable according to its terms.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >If any term or provision of these Event T&amp;Cs is determined to be illegal, unenforceable, or invalid in whole or in part for any reason, that provision shall be stricken from these Event T&amp;Cs and shall not affect the legality, enforceability or validity of the remainder of these Event T&amp;Cs. The parties acknowledge and agree that they are dealing with each other as independent contractors and nothing in these Event T&amp;Cs and its performance shall be construed as creating a joint venture or agency between PFX and Participant.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >PFX may delegate the performance of any services hereunder to its affiliates and contractors.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >These Event T&amp;Cs, together with the Terms, Privacy Statement, Broker Registration Terms, and any Additional Terms constitute the entire agreement between the parties regarding the subject matter, and supersedes all prior oral or written agreements or communications with regard to the subject matter described.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;&nbsp;</span>
          <span style="font-weight:normal;">Any notice to Participant may be provided by email.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >The headings of Sections of these Event T&amp;Cs are for convenience and are not to be used in interpreting these Event T&amp;Cs.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >As used in these Event T&amp;Cs, the word “including” means “including but not limited to.” Any delay in performance of any duties or obligations of either party will not be considered a breach of these Event T&amp;Cs if such delay is caused by a labor dispute, shortage of materials, fire, earthquake, flood, telecommunications or Internet failure, or any other event beyond the reasonable control of such party.</span>
        </li>
        <li
          style="margin-bottom:12pt; text-align:justify; font-family:Calibri; font-size:12pt; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:21.71pt;"
        >
          <span
            style="font:7pt 'Times New Roman';"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>CONTACTING US.&nbsp;
          <span
            style="font-weight:normal;"
          >Should you have any questions about these Event T&amp;Cs, contact us by sending an email to contact@pfxinc.com.</span>
          <span style="font-weight:normal;">&nbsp;&nbsp;</span>
          <span
            style="font-weight:normal;"
          >Please provide your name, mailing address, telephone number and email address so we can service you more quickly. You can also call us at&nbsp;</span>
          <span style="font-weight:normal; background-color:#fbfbfa;">855-949-3800</span>
          <span
            style="font-weight:normal;"
          >&nbsp;or write to us at PFX Inc., 1111 North Brand Boulevard, Suite 200, Glendale, California 91202.</span>
        </li>
      </ol>
      <p style="margin-top:0pt; margin-bottom:10pt; text-align:justify; font-size:12pt;">
        <span style="font-family:Calibri;">&nbsp;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StaticContentPage",
  props: {
    content: {
      type: String,
      required: false,
      default: () => ""
    }
  },
  data() {
    return {};
  },
  computed: {
    contentToShow() {
      return this.content || this.$route.meta.content;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/StaticContentPage.vue